<template>
  <div class="bg-white min-h-screen flex flex-col">
    <TSkipLink />
    <RenderTemplateHeader />

    <main id="main" class="flex-1">
      <UPage>
        <UPageHeader
          :class="[
            'sticky top-0 z-30 bg-white px-4 p-4 lg:px-8 lg:py-8 shadow-xs',
            headerMarginBottom,
          ]"
        >
          <slot name="sticky"></slot>
        </UPageHeader>
        <div :class="contentMarginTop">
          <TContainer>
            <slot name="top"></slot>
            <MenuBreadcrumb />
          </TContainer>
          <slot />
        </div>
      </UPage>
    </main>

    <RenderTemplateFooter v-if="!hideFooter" class="z-0" />
  </div>
</template>

<script setup lang="ts">
import { useTemplateDataComposable } from '~~/modules/template/composables/useTemplateDataComposable'

defineProps({
  headerMarginBottom: {
    type: String,
    default: 'mb-6',
  },
  contentMarginTop: {
    type: String,
    default: 'mt-8',
  },
  hideFooter: {
    type: Boolean,
    default: false,
  },
})

await useTemplateDataComposable({
  template: 'sticky',
})
</script>
